webpackJsonp([32239989425883],{

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.aboutPageQuery = exports.AboutPageTemplate = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(30);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Page = __webpack_require__(31);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _SideNav = __webpack_require__(64);
	
	var _SideNav2 = _interopRequireDefault(_SideNav);
	
	var _aboutModule = __webpack_require__(88);
	
	var _aboutModule2 = _interopRequireDefault(_aboutModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutPageTemplate = exports.AboutPageTemplate = function AboutPageTemplate(_ref) {
	  var pages = _ref.pages,
	      title = _ref.title,
	      content = _ref.content;
	  return _react2.default.createElement(
	    _Page2.default,
	    { className: _aboutModule2.default.component, title: 'About Us' },
	    _react2.default.createElement(_reactHelmet2.default, { title: title + ' | About Us' }),
	    _react2.default.createElement(_SideNav2.default, { pages: pages }),
	    _react2.default.createElement(
	      'article',
	      { className: _aboutModule2.default.article },
	      _react2.default.createElement(
	        'h2',
	        { className: _aboutModule2.default.articleTitle },
	        title
	      ),
	      _react2.default.createElement('div', {
	        className: _aboutModule2.default.articleContent,
	        dangerouslySetInnerHTML: { __html: content }
	      })
	    )
	  );
	};
	
	AboutPageTemplate.defaultProps = {
	  pages: [],
	  title: ''
	};
	
	AboutPageTemplate.propTypes = {
	  pages: _propTypes2.default.array,
	  title: _propTypes2.default.string,
	  content: _propTypes2.default.node.isRequired
	};
	
	var AboutPage = function AboutPage(_ref2) {
	  var data = _ref2.data;
	  var pages = data.allMarkdownRemark.edges;
	  var page = data.markdownRemark;
	  var title = page.frontmatter.title,
	      html = page.html;
	
	
	  return _react2.default.createElement(AboutPageTemplate, { pages: pages, title: title, content: html });
	};
	
	AboutPage.propTypes = {
	  data: _propTypes2.default.shape({
	    allMarkdownRemark: _propTypes2.default.shape({
	      edges: _propTypes2.default.array
	    }),
	    markdownRemark: _propTypes2.default.object
	  }).isRequired
	};
	
	exports.default = AboutPage;
	var aboutPageQuery = exports.aboutPageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"article":"src-templates----about-module---article---17Ys3","articleTitle":"src-templates----about-module---articleTitle---1bq-F","articleContent":"src-templates----about-module---articleContent---23muN","component":"src-templates----about-module---component---1yXGA"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-about-js-eb49351c6e9c78f476d3.js